export const blockIconsSearchShower = (
	<span className='material-symbols-outlined'>shower</span>
);
